import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";

import { IActionForProvider } from "../../../Lib/Actions/actions";
import { useBreakpoint } from "../../../Lib/UI/Hooks/useBreakpoint";
import { ITileCacheSeeder } from "../../MapComponents/TileCache/types";
import { IMapLayerSnapshotGenerator } from "../../MapComponents/snapshotGenerator";
import { getMinZoomForTileDownload } from "../../MapComponents/tileDownloadUtils";


export interface DownloadMapDataPopupProps {
    action: IActionForProvider<{ urlTemplate: string, urlSubdomains: string[] }, void>
    tileCacheSeeder: ITileCacheSeeder;
    snapshotGen?: IMapLayerSnapshotGenerator;
};

const useDownloadMapDataPopup = (props: DownloadMapDataPopupProps) => {

    const map = useMap();
    const breakpoint = useBreakpoint();

    const [urlTemplate, setUrlTemplate] = useState<string | null>(null);
    const [urlSubdomains, setUrlSubdomains] = useState<string[] | null>(null);
    const minZoom = !!map?.options?.crs ? getMinZoomForTileDownload(map.options.crs!.code!, breakpoint) : 0;
    const maxZoom = !!map ? map.getMaxZoom() : 0;

    useEffect(() => {

      if (!!props.action.params) {

        setUrlTemplate(props.action.params.urlTemplate);
        setUrlSubdomains(props.action.params.urlSubdomains);

        if (!!props.snapshotGen) {
          props.snapshotGen.setMap(map);
        }

      }

    }, [map, props.action.params, props.snapshotGen]);

    return {
        map,
        urlTemplate,
        urlSubdomains,
        minZoom, maxZoom
    };

};

export default useDownloadMapDataPopup;